<template>
    <form @submit.prevent="createLine()">

        <div class="form-group">
            <label>Libelle <span class="text-danger">*</span></label>
            <input type="text" class="form-control" v-model="form.libelle" required>
        </div>

        <button type="submit" class="btn btn-primary btn-block" :disabled="isLoading">
            <i class="fas fa-floppy-disk"></i> Enregistrer
            <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        </button>
    </form>
</template>
  
<script >
import $ from "jquery"
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CreateTypeMarchandise',
    inject: ['dialogRef'],
    data() {
        return {
            table: 'types_marchandises',
            baseUrl: this.$store.state.api_yams_livraisons,
            isLoading: false,
            form: {}
        }
    },
    methods: {
        createLine() {
            this.isLoading = true
            this.axios.post('/api/'+this.table, this.form).then(response => {
                this.isLoading = false
                if (response.data.success === true) {
                    this.resetForm()
                    $('#refresh' + this.table).click()
                    this.dialogRef.close()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                }
                else {
                    response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 7000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        resetForm() {
            this.form = {}
        }
    }
})
</script>
    